class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Coucke : le moteur Shopify classe mal les correspondances de titre (« farniente » sort derrière
// les 13 cartes Cambrai, « torchon farniente » au 127e rang). En page 1, tri Pertinence, sans
// filtre : on relance la recherche sur les titres (title:mot AND title:mot) et on remonte ces
// produits en tête de grille.
(function () {
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  const params = new URLSearchParams(location.search);
  const q = (params.get('q') || '').trim();
  if (!q || q.includes(':')) return;
  if ((params.get('page') || '1') !== '1') return;
  const sort = params.get('sort_by');
  if (sort && sort !== 'relevance') return;
  for (const key of params.keys()) if (key.startsWith('filter.')) return;

  const words = q.split(/[^\p{L}\p{N}]+/u).filter((w) => w.length > 1).slice(0, 6);
  if (!words.length) return;
  const precise = words.map((w) => 'title:' + w).join(' AND ');
  const url = `${location.pathname}?q=${encodeURIComponent(precise)}&type=product&section_id=${grid.dataset.id}`;

  const handleOf = (li) => {
    const a = li.querySelector('a[href*="/products/"]');
    return a ? new URL(a.href, location.origin).pathname.split('/').pop() : null;
  };

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = [...doc.querySelectorAll('#product-grid .product-grid_list > li')];
      const exact = new Set(items.map(handleOf).filter(Boolean));
      if (!exact.size || exact.size > 24) return;
      const list = grid.querySelector('.product-grid_list');
      list.querySelectorAll(':scope > li').forEach((li) => {
        if (exact.has(handleOf(li))) li.remove();
      });
      const nodes = items.map((li) => {
        const node = document.importNode(li, true);
        node.classList.remove('scroll-trigger', 'animate--slide-in');
        return node;
      });
      list.prepend(...nodes);
    })
    .catch(() => {});
})();
